// 工行
const routes = [
  {
    // 工商积分商城-H5宣传页需求
    path: '/icbcBankLeaflets',
    name: 'icbcBankLeaflets',
    component: () => import('@/views/icbcBank/leaflets/page.vue'),
    meta: {
      requiresAuth: false,
      title: '清爽一夏'
    },
  },



]

export default routes
